import { Link } from "react-router-dom";

const liveEvents = [
  {
    id: "live-1",
    title: "NBA常规赛：湖人 vs 勇士",
    time: "今日 10:30",
    viewers: "128万",
    status: "直播中",
    image: "https://readdy.ai/api/search-image?query=Basketball%20game%20action%20with%20two%20players%20competing%20under%20bright%20arena%20lights%2C%20dynamic%20sports%20photography%2C%20clean%20composition%2C%20professional%20stadium%20atmosphere&width=600&height=350&seq=yunsports-live-1&orientation=landscape",
  },
  {
    id: "live-2",
    title: "中超联赛：北京国安 vs 上海海港",
    time: "今日 19:35",
    viewers: "96万",
    status: "即将开始",
    image: "https://readdy.ai/api/search-image?query=Soccer%20match%20in%20Chinese%20stadium%20with%20players%20in%20action%20on%20green%20field%2C%20packed%20stadium%20crowd%2C%20professional%20sports%20photography%2C%20bright%20daylight&width=600&height=350&seq=yunsports-live-2&orientation=landscape",
  },
  {
    id: "live-3",
    title: "网球大师赛：男单半决赛",
    time: "明日 15:00",
    viewers: "52万",
    status: "预告",
    image: "https://readdy.ai/api/search-image?query=Tennis%20player%20serving%20ball%20on%20clay%20court%20with%20stadium%20background%2C%20professional%20sports%20photography%2C%20dramatic%20lighting%2C%20clean%20composition&width=600&height=350&seq=yunsports-live-3&orientation=landscape",
  },
  {
    id: "live-4",
    title: "电竞LPL夏季赛：JDG vs BLG",
    time: "今日 17:00",
    viewers: "210万",
    status: "直播中",
    image: "https://readdy.ai/api/search-image?query=E-sports%20arena%20with%20professional%20gamers%20on%20stage%2C%20massive%20LED%20screens%2C%20colorful%20dramatic%20lighting%2C%20packed%20audience%2C%20modern%20esports%20event&width=600&height=350&seq=yunsports-live-4&orientation=landscape",
  },
];

export default function LiveEvents() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门赛事</h2>
            <p className="text-foreground-600 text-sm">实时直播全球顶级体育赛事</p>
          </div>
          <Link
            to="/category/saishizhibo"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {liveEvents.map((event) => (
            <Link
              key={event.id}
              to="/category/saishizhibo"
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
                    event.status === "直播中"
                      ? "bg-red-500 text-white"
                      : event.status === "即将开始"
                        ? "bg-green-500 text-white"
                        : "bg-foreground-500 text-white"
                  }`}>
                    {event.status}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/60 backdrop-blur-sm rounded-full px-2.5 py-1">
                  <span className="text-white text-xs flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {event.viewers}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2">{event.title}</h3>
                <p className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                  {event.time}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}